import { render, staticRenderFns } from "./Investor.vue?vue&type=template&id=758eea5c&scoped=true&"
import script from "./Investor.vue?vue&type=script&lang=js&"
export * from "./Investor.vue?vue&type=script&lang=js&"
import style0 from "./Investor.vue?vue&type=style&index=0&id=758eea5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758eea5c",
  null
  
)

export default component.exports